import { Typography } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux';
import { getEOCActive } from '../../../reducer/eocActiveSlice';
import { getEOCConfig } from '../../../reducer/eocConfigSlice';

function TabDetail() {

    const eocActive = useSelector(getEOCActive);
    const eocConfig = useSelector(getEOCConfig);

    return (
        <div className="mx-auto max-w-7xl">
            <Typography
                sx={{ color: "#D48061" }}
                variant="subtitle2"
            >
                ผู้บังคับบัญชาเหตุการณ์
            </Typography>
            <Typography variant="body1">
                {eocActive?.incident_commander?.ic_name}
            </Typography>
            <Typography
                sx={{
                    color: "#D48061",
                    mt: 3,
                    mb: 1
                }}
                variant="subtitle2"
            >
                เจ้าหน้าที่เปิด EOC
            </Typography>
            <div className='w-full items-center grid gap-1 xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-8 lg:grid-cols-12'>
                <Typography variant="body2" className='col-span-1 w-full'>ชื่อ:</Typography>
                <Typography variant="body1" className='col-span-11 w-full'>
                    {eocActive?.creator_name}
                </Typography>
                <Typography variant="body2" className='col-span-1 w-full mt-2 md:mt-0'>โทรศัพท์:</Typography>
                <Typography variant="body1" className='col-span-11 w-full'>
                    {eocActive?.phone}
                </Typography>
                <Typography variant="body2" className='col-span-1 w-full mt-2 md:mt-0'>อีเมล:</Typography>
                <Typography variant="body1" className='col-span-11 w-full'>
                    {eocActive?.email}
                </Typography>
                <Typography variant="body2" className='col-span-1 w-full mt-2 md:mt-0'>หน่วยงาน:</Typography>
                <Typography variant="body1" className='col-span-11 w-full'>
                    {eocActive?.org_name}
                </Typography>
            </div>
            <Typography
                sx={{
                    color: "#D48061",
                    mt: 3,
                    mb: 1
                }}
                variant="subtitle2"
            >
                หน่วยงานที่มีส่วนร่วม
            </Typography>
            <div
                style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}
            >
                {eocActive?.participating_org?.map(
                    (dataparticipating, index) => (
                        <Typography
                            key={index}
                            sx={{
                                border: "1px solid #ccc",
                                display: "flex",
                                minWidth: "260px"
                            }}
                            className='rounded p-3'
                        >
                            {
                                <span>
                                    {dataparticipating.po_type_name}
                                    <br />
                                    {eocConfig?.config?.participating_org_type.map(
                                        (dataconf, index) => (
                                            <Typography key={index} variant="body1" component="span">
                                                {dataparticipating.po_type_id ===
                                                    dataconf.po_type_id ? (
                                                    <Typography variant="body2" component="span" sx={{ color: '#757575' }}>
                                                        {"เช่น "} {dataconf.example.toString().replaceAll(",", " ") + " "}
                                                    </Typography>
                                                ) : (
                                                    <></>
                                                )}
                                            </Typography>
                                        )
                                    )}
                                </span>
                            }
                        </Typography>
                    )
                )}
            </div>
        </div>
    )
}

export default TabDetail